<template>
    <div
        class="banner"
        :style="`width: ${bannerWidth}; height: ${bannerHeight}`"
    >
       <div
        class="banner__badge"
        :class="{'banner__badge--right-side': isBadgeAtRight}"
       >AD</div>
       <span v-if="!bannerImage" class="banner__text">Banner</span>
       <img
           v-else
           class="banner__image"
           :src="bannerImage.url"
           :alt="bannerImage.alt"
        >
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: {
            bannerWidth: {
                type: String,
                default: '100%',
            },
            bannerHeight: {
                type: String,
                default: '100%',
            },
            bannerImage: {
                type: Object,
                default: null,
            },
            isBadgeAtRight: {
                type: Boolean,
                default: false,
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~assets/css/_vars.scss";
    @import "~assets/css/_extension.scss";

    .banner {
        position: relative;
        background-color: $mainDarkBg;
        overflow: hidden;
        &__badge {
            position: absolute;
            top: 15px;
            left: 20px;
            @extend %flexCenter;
            width: 36px;
            height: 23px;
            border: 1px solid $transparentChipBg;
            font-size: $smallTextFontSize;
            text-transform: uppercase;
            color: #fff;
        }
        &__badge--right-side {
            position: absolute;
            left: calc(100% - 20px - 36px);
            background-color: rgba(#000000, 0.3);
        }
        &__text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: $fontSizeH2;
            font-weight: 700;
            color: rgba(#fff, .3);
        }
        &__image {
            display: block;
            @extend %imgCover;
        }
    }
</style>
